import React, { Component } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

import { COLOR_FONT_1 } from '../../colors';

/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
export class StateStackedColumnChart extends Component {
  /**
   *
   */
  componentDidMount() {
    const { chartId, data, nameDisplayCategory, nameDisplayState } = this.props;

    am4core.options.queue = true;
    am4core.options.onlyShowOnViewport = true;

    const chart = am4core.create(chartId, am4charts.XYChart3D);
    chart.data = data;

    const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'name_display';
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.labels.template.fill = am4core.color(COLOR_FONT_1);
    categoryAxis.renderer.labels.template.rotation = 270;
    categoryAxis.renderer.minGridDistance = 30;

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.title.fill = am4core.color(COLOR_FONT_1);
    valueAxis.title.text = 'Job Listing Appearance';
    valueAxis.renderer.labels.template.fill = am4core.color(COLOR_FONT_1);
    valueAxis.renderer.labels.template.adapter.add('text', (text) => `${text}%`);

    const stateSeries = chart.series.push(new am4charts.ColumnSeries3D());
    stateSeries.dataFields.valueY = 'percent_state';
    stateSeries.dataFields.categoryX = 'name_display';
    stateSeries.name = `${nameDisplayState} Market Share`;
    stateSeries.clustered = false;
    stateSeries.columns.template.tooltipText = `{categoryX} is [bold]{valueY}[/]% of ${nameDisplayCategory} jobs in ${nameDisplayState}`;

    const nationalSeries = chart.series.push(new am4charts.ColumnSeries3D());
    nationalSeries.dataFields.valueY = 'percent_national';
    nationalSeries.dataFields.categoryX = 'name_display';
    nationalSeries.name = 'National Market Share';
    nationalSeries.clustered = false;
    nationalSeries.columns.template.tooltipText = `{categoryX} is [bold]{valueY}[/]% of ${nameDisplayCategory} jobs Nationally`;

    this.chart = chart;
  }

  /**
   *
   */
  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  /**
   *
   */
  render() {
    return <div id={this.props.chartId} style={{ width: '100%', height: '512px' }} />;
  }
}
